<template>
    <div>
      <Header />
      <v-container>
        <v-row justify="center" align="center" fill-height>
          <v-col cols="12" xl="8">
            <v-card>
              <v-card-title>
                Kartonverwaltung
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Suche"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="cartons"
                :search="search"
                :loading="loading"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>Kartons</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="500px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                          Neuer Karton
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field v-model="editedItem.varId" label="Varianten ID" type="number"></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field v-model="editedItem.purchasingPrice" label="Einkaufspreis" type="number" step="1"></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field v-model="editedItem.price" label="Verkaufspreis" type="number" step="1"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="close">Abbrechen</v-btn>
                          <v-btn color="blue darken-1" text @click="save">Speichern</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                      <v-card>
                        <v-card-title class="headline">Sind Sie sicher, dass Sie diesen Karton löschen möchten?</v-card-title>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="closeDelete">Abbrechen</v-btn>
                          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.purchasingPrice="{ item }">
                  {{ (item.purchasingPrice / 100).toFixed(2) }} €
                </template>
                <template v-slot:item.price="{ item }">
                  {{ (item.purchasingPrice / 100).toFixed(2) }} €
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                  <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </template>
  
  <script>
  import Header from "@/views/general/header";
  import ShippingCartonService from "@/services/ShippingCartonService";
  
  export default {
    name: "ShippingCartonManagement",
    components: {
      Header
    },
    data: () => ({
      search: '',
      loading: true,
      dialog: false,
      dialogDelete: false,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Varianten ID', value: 'varId' },
        { text: 'Einkaufspreis', value: 'purchasingPrice' },
        { text: 'Verkaufspreis', value: 'price' },
        { text: 'Aktionen', value: 'actions', sortable: false }
      ],
      cartons: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        varId: 0,
        purchasingPrice: 0
      },
      defaultItem: {
        name: '',
        varId: 0,
        purchasingPrice: 0
      }
    }),
  
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'Neuer Karton' : 'Karton bearbeiten'
      },
    },
  
    watch: {
      dialog(val) {
        val || this.close()
      },
      dialogDelete(val) {
        val || this.closeDelete()
      },
    },
  
    created() {
      this.initialize()
    },
  
    methods: {
      async initialize() {
        this.loading = true
        try {
          const response = await ShippingCartonService.getAll()
          this.cartons = response.data
        } catch (error) {
          console.error("Fehler beim Laden der Kartons:", error)
          // Hier könnten Sie eine Benachrichtigung für den Benutzer anzeigen
        } finally {
          this.loading = false
        }
      },
  
      editItem(item) {
        this.editedIndex = this.cartons.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
  
      deleteItem(item) {
        this.editedIndex = this.cartons.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
  
      async deleteItemConfirm() {
        try {
          await ShippingCartonService.delete(this.editedItem.id)
          this.cartons.splice(this.editedIndex, 1)
        } catch (error) {
          console.error("Fehler beim Löschen des Kartons:", error)
          // Hier könnten Sie eine Benachrichtigung für den Benutzer anzeigen
        }
        this.closeDelete()
      },
  
      close() {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
  
      closeDelete() {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
  
      async save() {
        try {
          if (this.editedIndex > -1) {
            await ShippingCartonService.update(this.editedItem)
            Object.assign(this.cartons[this.editedIndex], this.editedItem)
          } else {
            const response = await ShippingCartonService.create(this.editedItem)
            this.cartons.push(response.data)
          }
          this.close()
        } catch (error) {
          console.error("Fehler beim Speichern des Kartons:", error)
          // Hier könnten Sie eine Benachrichtigung für den Benutzer anzeigen
        }
      },
    },
  }
  </script>